var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup1008(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.0371,
    cy: 14.9355,
    r: 13.1555,
    stroke: "#777777",
    strokeWidth: 1.81798
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8444 22.1992V20.285H15.6962V22.1992H13.8444ZM13.8444 18.4541V7.21858H15.6962V18.4541H13.8444Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1008);
export default __webpack_public_path__ + "static/media/Group 1008.318a2a2b2497b4d51d81c71f8c369f4e.svg";
export { ForwardRef as ReactComponent };